import React from 'react';
import './style/RouteTransition.scss';
import {
  ADMIN,
  BOOK_ACCESS_DENIED,
  BOOK_NOT_FOUND,
  COOKIE_ERROR,
  FILE_NOT_FOUND,
  HOME,
  NO_GROUPS,
  READER,
  SYSTEM_ERROR,
} from '../../api/redux-route/routes';
import {
  HundredPercentTransitionGroup,
  HundredPercentTransition,
} from '../core/common/HundredPercentTransitions';
import { matchPath } from 'react-router-dom';

export const DURATION = 600;

export let isTransitioning = false;

const errorRoutes = [
  BOOK_NOT_FOUND,
  BOOK_ACCESS_DENIED,
  COOKIE_ERROR,
  SYSTEM_ERROR,
  FILE_NOT_FOUND,
  NO_GROUPS,
];

export default class RouteTransition extends React.Component {
  lastPath = this.props.location.pathname;
  boundTransitionDone = this.transitionDone.bind(this);

  componentDidUpdate() {
    if (this.lastPath !== this.props.location.pathname) {
      isTransitioning = true;
    }
    this.lastPath = this.props.location.pathname;
  }

  transitionDone() {
    isTransitioning = false;
  }

  render() {
    let transition = '';
    let durations = {
      enter: DURATION,
      exit: DURATION,
    };
    let onEntered = this.boundTransitionDone;
    let onExited = this.boundTransitionDone;
    const path = this.props.location.pathname;
    let key = this.props.location.key;

    if (matchPath(path, { path: READER })) {
      transition = 'RouteTransition__Reader';
    } else if (errorRoutes.indexOf(path) !== -1) {
      transition = 'RouteTransition__Error';
    } else {
      durations = { enter: 0, exit: 0 };
      onEntered = null;
      onExited = null;

      // HOME has nested routes and we don't want to transition
      // when those change
      if (matchPath(path, { path: HOME })) {
        key = 'home';
      } else if (matchPath(path, { path: ADMIN })) {
        key = 'admin';
      }
    }

    return (
      <HundredPercentTransitionGroup>
        <HundredPercentTransition
          key={key}
          classNames={transition}
          timeout={durations}
          onEntered={onEntered}
          onExited={onExited}
        >
          {this.props.children}
        </HundredPercentTransition>
      </HundredPercentTransitionGroup>
    );
  }
}
